/* global module, require */
const crel = require('./createElement'),
	empty = require('./emptyElement'),
	finishedImg = require('../res/planner-finished.jpg');

function PlannerThanks(parent) {
	this.name = 'Quote Requested!';
	this.parent = parent;
	this.single = true;

	const { config } = parent;

	this.container = crel({ className: 'planner-thanks' });
	const main = crel({ _parent: this.container, className: 'main' });

	crel({
		_parent: main,
		_tag: 'h2',
		innerText: config.thanksH2 || 'Thank you for your request!',
	});
	crel({
		_parent: main,
		_tag: 'p',
		innerText:
			config.thanksP1 ||
			'You can put your feet up and wait for your quote now! In the mean time have a browse at our installations or get in touch with any queries you may have.',
	});
	crel({
		_parent: main,
		_tag: 'p',
		innerText: config.thanksP2 || 'Thanks for using 3D Visual Planner.',
	});
	crel({
		_parent: main,
		_tag: 'a',
		className: 'action-btn',
		href: config.thanksUrl1 || '#',
		innerText: config.thanksButton1 || 'Get in Touch',
	});

	crel({
		_parent: main,
		_tag: 'a',
		className: 'action-btn',
		href: config.thanksUrl2 || '/',
		innerText: config.thanksButton2 || 'Return to Home',
	});

	crel({
		_parent: this.container,
		_tag: 'img',
		src: config.thanksImg || finishedImg,
	});
}

PlannerThanks.prototype.activate = function() {
	const { container, parent } = this;

	parent.body.classList.add('requested-quote');

	empty(parent.content);
	parent.content.appendChild(container);
	parent.topbar.style.display = 'none';
};

module.exports = PlannerThanks;
